import React, { useEffect, createRef } from "react";
import useForm from "react-hook-form";
import { useTranslation } from 'react-i18next'
import * as Cookies from "js-cookie";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import { removeAllCookies } from "beaktShared/services/cookies";
import { setSessionCookie, getSessionCookie, setTokenCookie, setLanguageCookie, getLanguageCookie, getTokenCookie } from "beaktShared/services/session";
import { UsePostApi, UsePostApiLogin, UseGetApiSimple, UsePutApiAnonymous } from "beaktShared/services/crudeApiService";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/scss/react-flags-select.scss';
import Hidden from "@material-ui/core/Hidden";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import EsqueceuSenha from "./EsqueceuSenha.js";

import queryString from 'query-string';

const useStyles = makeStyles(styles);
const mainAPP = process.env.REACT_APP_MAIN

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function LoginPage({ history }) {
  const tenantId = window.location.host.split(':')[0].split('.')[0];
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");

  setTimeout(function () {
    setCardAnimation("");
  }, 700);

  const [showEsqueceuSenhaModal, setshowEsqueceuSenhaModal] = React.useState(false);

  const { register, handleSubmit, errors, setValue, clearError, setError } = useForm({ mode: "onBlur" });

  const [loading, setLoading] = React.useState(false);

  const intialValues = {
    id: 0,
    login: '',
    senha: '',
    emailEsqueceuSenha: ''
  };

  const [messageg, setmessageg] = React.useState({
    exist: false,
    message: "",
    type: "error"
  });

  const hangleshowMessage = (exist, message, type) => {
    setmessageg({
      exist: exist,
      message: message,
      type: type
    });
  }

  useEffect(() => {
    validateUrlParams();

    var token = getTokenCookie();

    var valuecookie = getSessionCookie();

    if (valuecookie != null && token != null && token.expired != true) {
      if (valuecookie.login != "") {
        if (valuecookie.estabelecimentoId == 0 && valuecookie.franquiaId == 0) {
          removeAllCookies();
          verifyFlag();
        }
        else if (valuecookie.estabelecimentoId != 0) {
          history.push("/adminclinic/home")
        }
        else {
          history.push("/adminmatriz/home")
        }
      }
    }
    else {
      removeAllCookies();
      verifyFlag();
    }

  }, []);

  const languageFlag = createRef()
  const verifyFlag = () => {
    const languageCookie = getLanguageCookie();
    if (languageCookie) {
      let language = languageCookie.language;
      let flag = "US";
      if (language === 'pt')
        flag = "BR";;
      languageFlag.current.updateSelected(flag);
    }
    else
      languageFlag.current.updateSelected("BR");
  }

  const [estabelecimentoFranqueado, setestabelecimentoFranqueado] = React.useState(true);

  const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(false);
  const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
  const [estabelecimentos, setestabelecimentos] = React.useState([]);
  const [estabelecimento, setestabelecimento] = React.useState(0);
  const [estabelecimentoDesc, setestabelecimentoDesc] = React.useState();
  const LoadEstabelecimentos = (usuarioId, tipoperfil) => {
    setisLoadingEstabelecimento(true);
    let endPoint = "estabelecimentos/ativos";
    if (tipoperfil != 0)
      endPoint += "/byusuario/" + usuarioId
    UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
        hangleshowMessage(true, result.message, 'error')
        setisLoadingEstabelecimento(false);

        return false;
      }

      setisLoadingEstabelecimento(false);
      setestabelecimentos(result.data);
      return true;
    });
  };
  const handleEstabelecimentoChange = event => {
    let value = event
    setestabelecimento(value);
    setValue("estabelecimento", value);
    if (value !== "")
      clearError("estabelecimento");

    var vefifyExists = estabelecimentos.filter(obj => {
      return obj.estabelecimentoId === value;
    });

    if (vefifyExists.length > 0) {
      let descricaoEstabelecimento = vefifyExists[0].codigoCredenciamentoUra != null ? vefifyExists[0].codigoCredenciamentoUra : "";
      setestabelecimentoDesc(descricaoEstabelecimento + " " + vefifyExists[0].descricao);
      setestabelecimentoFranqueado(((vefifyExists[0].franquiaId != null && vefifyExists[0].franquiaId > 0) ? true : false));
      setfranquia(vefifyExists[0].franquiaId);
      UseGetApiSimple("franquias/" + vefifyExists[0].franquiaId).then(result => {
        if (result.status == 200) {
          setlogoPequeno(result.data.logoPequeno);
          setlogoGrande(result.data.logoGrande);
        }
      })
    }
    else
      setestabelecimentoDesc('');

  };

  const [logoPequeno, setlogoPequeno] = React.useState(null);
  const [logoGrande, setlogoGrande] = React.useState(null);
  const [showSelectFranquia, setshowSelectFranquia] = React.useState(false);
  const [isLoadingFranquia, setisLoadingFranquia] = React.useState(false);
  const [franquias, setfranquias] = React.useState([]);
  const [franquia, setfranquia] = React.useState(0);
  const [franquiaDesc, setfranquiaDesc] = React.useState('');
  const [utilizaCSJPix, setUtilizaCSJPix] = React.useState(false);
  const [habilitaControleRoyalties, setHabilitaControleRoyalties] = React.useState(false);
  const LoadFranquias = () => {
    setisLoadingFranquia(true);
    const endPoint = "franquias/ativos"
    UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
        hangleshowMessage(true, result.message, 'error')
        setisLoadingFranquia(false);
        return false;
      }

      setisLoadingFranquia(false);
      setfranquias(result.data);
      return true;
    });
  };
  const handleFranquiaChange = event => {
    let value = event
    setfranquia(value);
    setValue("franquia", value);
    if (value !== "")
      clearError("franquia");

    var vefifyExists = franquias.filter(obj => {
      return obj.franquiaId === value;
    });

    if (vefifyExists.length > 0) {
      setlogoPequeno(vefifyExists[0].logoPequeno);
      setlogoGrande(vefifyExists[0].logoGrande);
      setfranquiaDesc(vefifyExists[0].descricao);
    }
    else
      setfranquiaDesc('');

  };

  const validateUrlParams = () => {
    let urls = history.location.search;
    let params = queryString.parse(urls);

    if (params.token != null) {
      setisLoadingEstabelecimento(false);
      setshowDefinePass(true);

      let loginToken = (atob(params.token));
      setValue('login', loginToken)

    }
  }

  const [showDefinePass, setshowDefinePass] = React.useState(false);
  const handleLoginChange = (e) => {

    hangleshowMessage(false, '', '');

    if (showSelectEstabelecimentos || showSelectFranquia) {
      var valuec = getSessionCookie();

      if (valuec.login !== e.target.value) {
        setshowSelectFranquia(false);
        setshowSelectEstabelecimentos(false);
        setshowEscolherModulo(false);
        setSessionCookie(null);
      }
    }

    let obj = {
      login: e.target.value
    }

    let parametros = history.location.search;
    //se não tiver parametros na url significa que não é o link enviado no email (da ação "esqueceu senha").
    if (parametros == "") {
      const endPoint = "usuarios/verifyfirstacess/";
      UsePostApiLogin(endPoint, obj).then(result => {
        if (result.status !== 200) {
          hangleshowMessage(true, result.message, 'error')
          return false;
        }
        setshowDefinePass(result.data);
        return true;
      });
    }
  }

  const [showEscolherModulo, setshowEscolherModulo] = React.useState(false);
  const [moduloLogar, setmoduloLogar] = React.useState('0');
  const [showModuloAdmin, setshowModuloAdmin] = React.useState(false);

  //limpa os cookies e desloga de qualquer usuario já logado, para acessar com novo login
  const [LimpaCookies, setLimpaCookies] = React.useState(true);

  const onSubmit = (data) => {
    if (LimpaCookies) {
      var token = getTokenCookie();

      var valuecookie = getSessionCookie();

      if (valuecookie != null && token != null && token.expired != true) {
        Cookies.remove("token");
        Cookies.remove("session");
        localStorage.removeItem('carrinhoVenda');
      }
      setTimeout(() => {
        Login(data);
      }, 1000);
      setLimpaCookies(false);
    }
    else {
      Login(data);
    }
  };

  const Login = (data) => {
    hangleshowMessage(false, '', '');
    setLoading(true);

    if (showDefinePass) {
      setLoading(false);
      if (data.definasenha === "")
        return setError("definasenha", "required")

      if (data.confirmasenha === "")
        return setError("confirmasenha", "required")

      if (!(data.definasenha === data.confirmasenha)) {
        hangleshowMessage(true, "Nova Senha e Confirmar Senha devem ser iguais!", 'error')
        return;
      }

      if (data.definasenha.indexOf('#') > -1 || data.confirmasenha.indexOf('#') > -1) {
        hangleshowMessage(true, "Não é possível inserir o caractere # na criação de senha!", 'error')
        return;
      }

      let obj = {
        login: data.login,
        password: data.definasenha
      }

      setLoading(true);
      let endPoint = 'usuarios/alterpassword';
      UsePutApiAnonymous(endPoint, '', obj).then(result => {
        if (result.status !== 200) {
          hangleshowMessage(true, result.message, 'error')
          setLoading(false);
          return false;
        }

        setshowDefinePass(false);
        setLoading(false);
        hangleshowMessage(true, "Senha atualizada com sucesso!", 'success')
        return true;
      });

      return;
    }

    if (showSelectEstabelecimentos) {
      setLoading(false);
      if (estabelecimento === "" || estabelecimento === 0)
        return setError("estabelecimento", "required")

      var valuec = getSessionCookie();
      valuec.estabelecimentoId = estabelecimento;
      valuec.estabelecimentoDescricao = estabelecimentoDesc;
      valuec.estabelecimentoFranqueado = estabelecimentoFranqueado;
      valuec.logoPequeno = logoPequeno;
      valuec.logoGrande = logoGrande;
      if (franquias !== null) {
        const franquiaRet = franquias.find(f => f.franquiaId === franquia);
        const utilizaCSJPixRet = franquiaRet ? franquiaRet.utilizaCSJPix : false;
        valuec.utilizaCSJPix = utilizaCSJPixRet;
        setUtilizaCSJPix(utilizaCSJPixRet)
      }
      setSessionCookie(valuec);
      successRedirect('0');
      return true;
    }

    if (showSelectFranquia || (moduloLogar == "1" && franquia != 0)) {
      setLoading(false);
      if (franquia === "" || franquia === 0)
        return setError("franquia", "required")

      var valuec = getSessionCookie();
      valuec.franquiaId = franquia;
      valuec.franquiaDescricao = franquiaDesc;
      if (logoPequeno != null)
        valuec.logoPequeno = logoPequeno;
      if (logoGrande != null)
        valuec.logoGrande = logoGrande;
      setSessionCookie(valuec);

      successRedirect('1');
      return true;
    }

    if (moduloLogar == "2") {
      var valuec = getSessionCookie();
      if (valuec.tipoPerfil == 0) {
        successRedirect('2');
        return true;
      }
    }

    let obj = {
      login: data.login,
      password: data.senha
    }
    let endPoint = 'usuarios/authenticate';
    setLoading(true);
    UsePostApiLogin(endPoint, obj).then(result => {
      if (result.status !== 200) {
        hangleshowMessage(true, result.message, 'error')
        setLoading(false);
        return false;
      }
      
      removeAllCookies();
      result.data.usuarioDto.habilitaControleRoyalties = habilitaControleRoyalties;
      setSessionCookie(result.data.usuarioDto);

      var token = {
        accessToken: result.data.accessToken,
        expiration: result.data.expiration
      }

      setTokenCookie(token);

      //ACESSO MASTER
      if (result.data.usuarioDto.tipoPerfil == 0) {
        LoadFranquias();
        LoadEstabelecimentos(result.data.usuarioDto.id, result.data.usuarioDto.tipoPerfil);
        if (mainAPP === 'CLINIC') {
          setshowModuloAdmin(true);
          setshowEscolherModulo(true);
          setmoduloLogar('0')
          setshowSelectEstabelecimentos(true);
        }
        else if (mainAPP === 'DAY') {
          setshowSelectEstabelecimentos(true);
        }
      }
      // ACESSO USUÁRIO MATRIZ COM PERMISSÃO PARA ACESSAR ESTABELECIMENTOS
      else if (result.data.usuarioDto.tipoPerfil == 4 && result.data.usuarioDto.acessaTodosEstabelecimentos) {
        setfranquia(result.data.usuarioDto.franquiaId);
        setfranquiaDesc(result.data.usuarioDto.franquiaDescricao);

        LoadEstabelecimentos(result.data.usuarioDto.id, result.data.usuarioDto.tipoPerfil);
        if (mainAPP === 'CLINIC') {
          setshowEscolherModulo(true);
          setmoduloLogar('0')
          setshowSelectEstabelecimentos(true);
        }
        else if (mainAPP === 'DAY') {
          setshowSelectEstabelecimentos(true);
        }
      }
      // ACESSO ESTABELECIMENTO OU PROFISSIONAL
      else if ((result.data.usuarioDto.tipoPerfil == 1 || result.data.usuarioDto.tipoPerfil == 2) && result.data.usuarioDto.estabelecimentoId == 0) {
        LoadEstabelecimentos(result.data.usuarioDto.id, result.data.usuarioDto.tipoPerfil);
        setshowSelectEstabelecimentos(true);
      }
      // OUTROS ACESSOS
      else {
        if (result.data.usuarioDto.tipoPerfil == 4) {
          setmoduloLogar('1')
          successRedirect('1');
        }
        else {
          setmoduloLogar('0')
          successRedirect('0');
        }
      }
      setUtilizaCSJPix(result.data.usuarioDto.utilizaCSJPix);
      setLoading(false);
      return true;
    });

  }

  const closemodalEsqueceuSenha = () => {
    setshowEsqueceuSenhaModal(false)
  }

  const successRedirect = (modulo) => {
    return setTimeout(() => {
      if (mainAPP === 'DAY') {
        history.push("/adminday/agenda")
      }
      else if (mainAPP === 'CLINIC') {
        if (modulo === '0')
          history.push("/adminclinic/home")
        else if (modulo === '1')
          history.push("/adminmatriz/home")
        else if (modulo === '2')
          history.push("/admin/home")
      }
    }, 1500);

  };

  const handleChangeModuloLogar = event => {
    setmoduloLogar(event.target.value);
    if (event.target.value === '0')//Modulo Clinica
    {
      setshowSelectEstabelecimentos(true);
      setshowSelectFranquia(false);
    }
    if (event.target.value === '1')//Modulo Matriz
    {
      setshowSelectEstabelecimentos(false);
      var valuec = getSessionCookie();
      if (valuec.franquiaId === 0)
        setshowSelectFranquia(true);
    }
    if (event.target.value === '2')//Modulo Admin
    {
      setshowSelectEstabelecimentos(false);
      setshowSelectFranquia(false);
    }
  };

  const onSelectFlag = (countryCode) => {
    let language = "pt";
    if (countryCode === "BR")
      language = "pt";
    else
      language = "en";

    i18n.changeLanguage(language);
    setLanguageCookie({ language: language });
  };

  React.useEffect(() => {
    if (tenantId === 'localhost' || 
        tenantId === 'dm2' || 
        tenantId === 'dm2-day' || 
        tenantId === 'qaclinic') {
      setHabilitaControleRoyalties(true);
    }
  }, [tenantId]);

  let [imgbemvindo] = React.useState(require("assets/img/1on1_meeting_software_hr_app.png"));
  return (
    <div className={classes.container} style={{ height: '700px', marginTop: '80px' }}>
      <GridContainer justify="center">
        <GridItem xs={10} sm={10} md={10}>
          <Card>
            <CardBody>
              <GridContainer justify="center" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
                <GridItem md={5}>
                  <Hidden smDown implementation="css">
                    <div style={{ height: '100%', width: '100%', borderRight: '1px solid #efefef', paddingRight: '30px' }}>
                      <h4><b>{t('login.welcome')}!</b></h4>
                      <p>
                        {t('login.text_description')}.
                      </p>
                      <img alt="logo" style={{ width: '80%', margin: '0 auto' }} src={imgbemvindo} />
                    </div>
                  </Hidden>
                </GridItem>
                <GridItem xs={10} sm={8} md={5}>
                  <center><h3>{t('login.login')}</h3> </center>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <FormControl fullWidth className={classes.formControl}>
                          <div style={{ textAlign: 'right', position: 'absolute', right: '0px', top: '-20px' }}>
                            <ReactFlagsSelect
                              countries={["US", "BR"]}
                              ref={languageFlag}
                              customLabels={{ "US": "EN-US", "BR": "PT-BR" }}
                              showSelectedLabel={false}
                              showOptionLabel={false}
                              onSelect={(e) => onSelectFlag(e)}
                            />
                          </div>
                        </FormControl>
                        <br />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <FormControl fullWidth className={classes.formControl}>
                          <TextField
                            error={errors.login ? true : false}
                            label={t('login.login') + " *"}
                            inputRef={register({ required: true })}
                            name="login"
                            onBlur={handleLoginChange}
                            defaultValue={''}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Face className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                              ),
                              autoComplete: "off"
                            }}
                            inputProps={{ maxLength: 50 }}
                          />
                          <FormHelperText className={classes.labelRootError}>
                            {errors.login && <span>{t('label.required')} </span>}
                          </FormHelperText>
                        </FormControl>
                        <br />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>

                        {!showDefinePass &&
                          <FormControl fullWidth className={classes.formControl}>
                            <TextField
                              error={errors.senha ? true : false}
                              label={t('login.password') + " *"}
                              inputRef={register({ required: true })}
                              name="senha"
                              defaultValue={intialValues.senha}
                              type="password"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Icon className={classes.inputAdornmentIcon}>
                                      lock_outline
                                    </Icon>
                                  </InputAdornment>
                                ),
                                autoComplete: "off"
                              }}
                              inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText className={classes.labelRootError}>
                              {errors.senha && <span>{t('label.required')} </span>}
                            </FormHelperText>
                          </FormControl>
                        }

                        {showDefinePass &&
                          <div>
                            <FormControl fullWidth className={classes.formControl}>
                              <TextField
                                label={t('login.set_new_password') + " *"}
                                error={errors.definasenha ? true : false}
                                inputRef={register({ required: true })}
                                name="definasenha"
                                type="password"
                                InputProps={{
                                  autoComplete: "off"
                                }}
                                inputProps={{ maxLength: 10 }}
                              />
                              <FormHelperText className={classes.labelRootError}>
                                {errors.definasenha && <span> {t('label.required')}  </span>}
                              </FormHelperText>
                            </FormControl>

                            <FormControl fullWidth className={classes.formControl}>
                              <TextField
                                label={t('login.confirm_new_password') + " *"}
                                error={errors.confirmasenha ? true : false}
                                inputRef={register({ required: true })}
                                name="confirmasenha"
                                type="password"
                                InputProps={{
                                  autoComplete: "off"
                                }}
                                inputProps={{ maxLength: 10 }}
                              />
                              <FormHelperText className={classes.labelRootError}>
                                {errors.confirmasenha && <span> {t('label.required')} </span>}
                              </FormHelperText>
                            </FormControl>
                          </div>
                        }

                        {showEscolherModulo &&
                          <div className="mb-2">
                            <label>{t('login.module_access')}:</label><br />
                            <div style={{ float: 'left' }}>
                              <FormControlLabel
                                control={
                                  <Radio
                                    checked={moduloLogar === "0"}
                                    onChange={handleChangeModuloLogar}
                                    value="0"
                                    name="radio button enabled"
                                    aria-label="0"
                                    icon={<FiberManualRecord className={classes.radioUnchecked} />}
                                    checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                                  />
                                }
                                label={t('label.establishment')}
                              />
                            </div>
                            <div>
                              <FormControlLabel
                                control={
                                  <Radio
                                    checked={moduloLogar === "1"}
                                    onChange={handleChangeModuloLogar}
                                    value="1"
                                    name="radio button enabled"
                                    aria-label="1"
                                    icon={<FiberManualRecord className={classes.radioUnchecked} />}
                                    checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                                  />
                                }
                                label={t('label.franchise')}
                              />
                            </div>
                            {showModuloAdmin &&
                              <div>
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={moduloLogar === "2"}
                                      onChange={handleChangeModuloLogar}
                                      value="2"
                                      name="radio button enabled"
                                      aria-label="1"
                                      icon={<FiberManualRecord className={classes.radioUnchecked} />}
                                      checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                                    />
                                  }
                                  label="Administrador"
                                />
                              </div>
                            }
                          </div>
                        }

                        {showSelectEstabelecimentos &&
                          <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                              {t('label.establishment')} *
                            </label>
                            <Select
                              classNamePrefix="select"
                              styles={ValidSelect(errors.estabelecimento ? true : false)}
                              isSearchable={true}
                              isLoading={isLoadingEstabelecimento}
                              name="estabelecimento"
                              placeholder={t('label.select') + " ..."}
                              options={estabelecimentos}
                              value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                              getOptionLabel={({ descricao }) => descricao}
                              getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                              onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                              ref={() => register({ name: "estabelecimento" })
                              }
                            />
                            <FormHelperText className={classes.labelRootError}>
                              {errors.estabelecimento && <span> {t('label.required')}</span>}
                            </FormHelperText>
                          </FormControl>
                        }

                        {showSelectFranquia &&
                          <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.franquia ? "select__label select__label_error" : "select__label"}>
                              {t('label.franchise')} *
                            </label>
                            <Select
                              classNamePrefix="select"
                              styles={ValidSelect(errors.franquia ? true : false)}
                              isSearchable={true}
                              isLoading={isLoadingFranquia}
                              name="franquia"
                              placeholder={t('label.select') + " ..."}
                              options={franquias}
                              value={franquias.filter(({ franquiaId }) => franquiaId === franquia)}
                              getOptionLabel={({ descricao }) => descricao}
                              getOptionValue={({ franquiaId }) => franquiaId}
                              onChange={(value) => handleFranquiaChange(value.franquiaId !== null ? value.franquiaId : "")}
                              ref={() => register({ name: "franquia" })
                              }
                            />
                            <FormHelperText className={classes.labelRootError}>
                              {errors.franquia && <span>  {t('label.required')} </span>}
                            </FormHelperText>
                          </FormControl>
                        }
                        <b className={messageg.type === 'error' ? classes.labelRootError : classes.labelRootSuccess}>
                          {messageg.exist && <span> {messageg.message} </span>}
                        </b>
                        <br />
                      </GridItem>
                    </GridContainer>
                    {mainAPP === 'DAY' &&
                      <a href="/institutionalday/register">{t('login.sign_up_free')}.</a>}

                    <CardFooter className={classes.justifyContentCenter}>
                      <Button color="primary" simple size="lg" block onClick={() => setshowEsqueceuSenhaModal(true)}>
                        {t('login.forgot_password')}
                      </Button>
                      <Button type="submit" className={classes.marginRight} color="primary" size='lg' block>
                        {t('login.login')}  {loading && <label style={{ color: 'white', marginLeft: '5px' }}> <LoadingIcon className="rotate rsmall" /></label>}
                      </Button>

                    </CardFooter>
                  </form>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal
        }}
        open={showEsqueceuSenhaModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setshowEsqueceuSenhaModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <EsqueceuSenha classes={classes} _closemodalEsqueceuSenha={closemodalEsqueceuSenha} />

      </Dialog>

    </div>
  );
}
